"use client";

import React, { useState } from "react";
import {
    Controller,
    Control,
    FieldError,
    Path,
    FieldValues,
} from "react-hook-form";
import { IoAlertCircleOutline } from "react-icons/io5";
import { MdFileDownload } from "react-icons/md";

interface InputTypeFileProps<TFormData extends FieldValues> {
    name: Path<TFormData>;
    control: Control<TFormData>;
    error?: FieldError;
    label: string;
    accept?: boolean;
}

const CustomfileInput = <TFormData extends FieldValues>({
    name,
    control,
    error,
    label,
    accept,
}: InputTypeFileProps<TFormData>) => {
    const inputId = `${name}-file-input`;
    const [fileName, setFileName] = useState<string | null>(null);

    return (
        <div className="flex items-center justify-center w-full bg-white">
            <div className="w-full mx-auto rounded-lg overflow-hidden">
                <div className="w-full p-3">
                    <div className="relative border-dotted h-24 w-full rounded-lg border-2 border-blue-700 bg-gray-100 flex justify-center items-center">
                        <Controller
                            name={name}
                            control={control}
                            render={({ field }) => (
                                <>
                                    <input
                                        id={inputId}
                                        type="file"
                                        accept={
                                            accept
                                                ? undefined
                                                : "image/*,application/zip,application/x-zip,application/x-zip-compressed"
                                        }
                                        onChange={(e) => {
                                            const file =
                                                e.target.files?.[0] || null;
                                            setFileName(
                                                file ? file.name : null
                                            );
                                            field.onChange(file);
                                        }}
                                        className="absolute top-0 left-0 h-full w-full opacity-0 cursor-pointer"
                                        name={name}
                                    />
                                    <label
                                        htmlFor={inputId}
                                        className="flex flex-col items-center justify-center cursor-pointer text-center"
                                    >
                                        <i className="text-blue-700 text-2xl">
                                            <MdFileDownload />
                                        </i>
                                        <span className="block text-red-500 font-normal">
                                            {fileName || label}
                                        </span>
                                    </label>
                                </>
                            )}
                        />
                    </div>
                    {error && (
                        <span className="text-red-400 text-sm mt-2 flex items-center">
                            <IoAlertCircleOutline className="inline mr-1" />{" "}
                            {error.message}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CustomfileInput;
